import { config } from "@/config";
export const PerfilService = {
    // Obtener el perfil del usuario
    async getProfile() {
        try {
            const response = await fetch(`${config.API_URL}/api/Usuario/profile`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Error al obtener el perfil");
            }
            const result = await response.json();
            if (!result.datos) {
                console.error('Se esperaba un objeto con la propiedad "datos" pero se recibió:', result);
                throw new Error("Formato de respuesta inesperado");
            }
            return result.datos;
        }
        catch (error) {
            throw new Error(error.message || "Error al obtener el perfil");
        }
    },
    async getProfileN() {
        try {
            const response = await fetch(`${config.API_URL}/api/Usuario/profile`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Error al obtener el perfil");
            }
            const result = await response.json();
            if (!result.datos) {
                console.error('Se esperaba un objeto con la propiedad "datos" pero se recibió:', result);
                throw new Error("Formato de respuesta inesperado");
            }
            return result.datos;
        }
        catch (error) {
            throw new Error(error.message || "Error al obtener el perfil");
        }
    },
    // Actualizar el perfil del usuario
    async updateProfile(user) {
        try {
            const response = await fetch(`${config.API_URL}/api/Usuario/profile`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(user),
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Error al actualizar el perfil");
            }
            const result = await response.json();
            if (!result.datos) {
                console.error('Se esperaba un objeto con la propiedad "datos" pero se recibió:', result);
                throw new Error("Formato de respuesta inesperado");
            }
            return result;
        }
        catch (error) {
            throw new Error(error.message || "Error al actualizar el perfil");
        }
    },
    // Actualizar la imagen de perfil del usuario
    async updateProfileImage(file) {
        const formData = new FormData();
        formData.append("imagenPerfil", file);
        try {
            const response = await fetch(`${config.API_URL}/api/Usuario/profile/image`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
                body: formData,
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Error al actualizar la imagen de perfil");
            }
            const result = await response.json();
            if (!result.datos) {
                console.error('Se esperaba un objeto con la propiedad "datos" pero se recibió:', result);
                throw new Error("Formato de respuesta inesperado");
            }
            return result; // Devolver el resultado para manejarlo en el componente
        }
        catch (error) {
            throw new Error(error.message || "Error al actualizar la imagen de perfil");
        }
    },
};
